import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/Axelerate_logo.svg'
import _imports_1 from '../../assets/Ilustration.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "min-h-screen flex flex-col items-center justify-center rounded bg-background"
}
const _hoisted_3 = { class: "flex flex-col bg-white lg:shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-lg w-full max-w-md" }
const _hoisted_4 = { class: "pt-5 pb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "login logo",
  class: "w-5/12 lg:pb-5"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  alt: "illustration",
  class: "w-5/12 lg:pb-5"
}
const _hoisted_7 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-1/4 w-1/4 text-red-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold self-start text-xl sm:text-2xl text-gray" }, " Email Verification ", -1)
const _hoisted_11 = { class: "mt-8 mb-8 text-black text-sm overflow-clip tracking-normal text-justify" }
const _hoisted_12 = { class: "flex justify-center items-center text-sm" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Return to", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 inline-flex items-center text-primary font-bold text-sm text-centerml-2" }, "Login", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Loading, {
          active: _ctx.isLoading,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
          "can-cancel": false,
          loader: "spinner",
          color: "#8908F9",
          width: 128,
          height: 128,
          opacity: 1,
          "is-full-page": true
        }, null, 8, ["active"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (!_ctx.error)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.message), 1),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_router_link, { to: "/log-in" }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ])
        ])
      ]))
}